export const isSuccessOrAllFieldsAreFilled = (success: boolean, formValues: object) => {
  if (success) {
    return true;
  }

  return !Object.values(formValues).every((value) => Boolean(value))
};

export const isSuccessOrAllRequiredFieldsAreFilled = (success: boolean, formValues: object, optionalFields: string[]): boolean => {
  if (success) {
    return true;
  }

  return !Object.entries(formValues).every(([key, value]) => {
    if (optionalFields.includes(key)) {
      return true
    }

    if (Array.isArray(value)) {
      return value != null && value.length > 0;
    }

    return Boolean(value);
  })
}
